import { FetchHelper, fetchSymbol } from "./api/fetch/fetch-helper";
import { z } from "zod";
import { zodErrorMap } from "./utils/zod-error";
import { GlobalInterceptor } from "./api/fetch/interceptors";
import { initCartEvents } from "./cart.events";

declare global {
  interface Window {
    [fetchSymbol]: FetchHelper;
    Shopify: {
      routes: {
        root: string;
      }
    }
  }
}

z.setErrorMap(zodErrorMap);

const pureFetch = window.fetch;
const interceptor = new GlobalInterceptor();
window.fetch = interceptor.interceptFetchApi(window.fetch);
interceptor.interceptAjaxApi(window.XMLHttpRequest);
window[fetchSymbol] = new FetchHelper(window.fetch, pureFetch); 

export * from "./api";
export const { interceptBefore, interceptAfter } = interceptor.frontEndMethods;

initCartEvents(interceptor);